import type { Player, MyEnrollment } from '@swiss-magic/shared-types';
import { ApiError, del, get, post } from './core';

export function enroll(tournamentId: string): Promise<Player> {
  return post(`/tournaments/${tournamentId}/enroll`);
}

export function unenroll(tournamentId: string): Promise<{ ok: boolean }> {
  return del(`/tournaments/${tournamentId}/enrollment`);
}

export async function getMyEnrollment(
  tournamentId: string,
): Promise<MyEnrollment | null> {
  try {
    return await get<MyEnrollment>(`/tournaments/${tournamentId}/my-enrollment`);
  } catch (err) {
    if (err instanceof ApiError && err.status === 404) return null;
    throw err;
  }
}
